export default "__VITE_ASSET__egv7wqii__"